import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-lg leading-6 font-medium text-gray-900"
}
const _hoisted_2 = { class: "text-sm text-gray-500 mt-2" }

import { useSlots, withDefaults } from "vue"

interface Props {
    textCenter?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsInfo',
  props: {
    textCenter: { type: Boolean, default: true }
  },
  setup(__props: any) {

const slots = useSlots()

function hasTitle() {
    return !!slots.title
}

const props = __props

function getWrapperStyle() {
    return props.textCenter ? "text-center" : ""
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([getWrapperStyle()])
  }, [
    (hasTitle())
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, [
          _renderSlot(_ctx.$slots, "title")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})